import * as React from 'react';

import URI from 'jsuri';

import Breadcrumbs from 'bundles/browse/components/Domain/Breadcrumbs';
import type { Domain } from 'bundles/browse/components/Domain/types/Domain';
import type { Subdomain } from 'bundles/browse/components/Domain/types/SubDomain';
import { BROWSE_ROOT_URL } from 'bundles/browse/constants';
import { withMediaMinWidthMobile } from 'bundles/browse/utils';
import MobileBreadCrumb from 'bundles/page/components/MobileBreadCrumb';

import _t from 'i18n!nls/browse';

type PropsFromCaller = {
  domain: Domain;
  subdomain?: Subdomain;
};

type Props = PropsFromCaller & {
  matches: boolean;
};

export const BrowseBreadcrumbs = ({ matches, domain, subdomain }: Props) => {
  const domainUri = new URI();
  let href = BROWSE_ROOT_URL;
  let label = _t('Explore');
  if (subdomain) {
    domainUri.setPath(`${BROWSE_ROOT_URL}/${domain.slug || domain.id}`);
    href = domainUri.toString();
    label = domain.name;
  }
  return (
    <div className="rc-BrowseBreadcrumbs">
      {matches ? (
        <Breadcrumbs domain={domain} subdomain={subdomain} />
      ) : (
        <div className="mobile-breadcrumb" aria-label={_t('Breadcrumb')}>
          <MobileBreadCrumb href={href} label={label} styles={{ color: 'var(--cds-color-neutral-primary-invert)' }} />
        </div>
      )}
    </div>
  );
};

export default withMediaMinWidthMobile(BrowseBreadcrumbs);
